import { render, staticRenderFns } from "./LimitCreate.vue?vue&type=template&id=e1823dac&"
import script from "./LimitCreate.vue?vue&type=script&lang=ts&"
export * from "./LimitCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports